export const REGIONS = [
  { label: 'IAD (us-east-1)', value: 'us-east-1', description: 'NA' },
  { label: 'PDX (us-west-2)', value: 'us-west-2', description: 'FE' },
  { label: 'ZAZ (eu-south-2)', value: 'eu-south-2', description: 'EU' },
];

// API base URLs — injected at build time via webpack DefinePlugin from the
// https://gamma.na.beacon.fintech.amazon.dev/api / https://gamma.fe.beacon.fintech.amazon.dev/api / https://gamma.zaz.beacon.fintech.amazon.dev/api templates that
// FinTechLastMileBeaconWebsiteCDK's KatalDeploymentLambda substitutes at
// deploy time. Each deployed bundle already carries THAT stage's regional
// API URLs, so every stage row references the same three globals.
export const API_BASES: Record<string, Record<string, string>> = {
  Alpha: {
    'us-east-1': API_BASE_IAD,
    'us-west-2': API_BASE_PDX,
    'eu-south-2': API_BASE_ZAZ,
  },
  Beta: {
    'us-east-1': API_BASE_IAD,
    'us-west-2': API_BASE_PDX,
    'eu-south-2': API_BASE_ZAZ,
  },
  Gamma: {
    'us-east-1': API_BASE_IAD,
    'us-west-2': API_BASE_PDX,
    'eu-south-2': API_BASE_ZAZ,
  },
  Prod: {
    'us-east-1': API_BASE_IAD,
    'us-west-2': API_BASE_PDX,
    'eu-south-2': API_BASE_ZAZ,
  },
};

export const DEFAULT_STAGE = 'Alpha';
export const DEFAULT_REGION = 'us-east-1';

/**
 * Derives the stage from the current URL hostname.
 */
export const getStageFromUrl = (): string => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'Alpha';
  if (hostname.includes('alpha')) return 'Alpha';
  if (hostname.includes('beta')) return 'Beta';
  if (hostname.includes('gamma')) return 'Gamma';
  if (hostname.includes('prod')) return 'Prod';
  return DEFAULT_STAGE;
};

export const getApiBase = (stage: string, region: string): string => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api';
  }
  return API_BASES[stage]?.[region] || '';
};
